export default {
      id: "file-image-usage",
      viewBox: "0 0 384 512",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#file-image",
      toString: function () {
        return this.url;
      }
    }